export default __webpack_public_path__ + "static/media/9.bb845a30.jpg";